import React, { useState } from "react";
import EditEarlyReturnModal from "./EditEarlyReturnModal2";
import { useTheme } from "../hooks/useTheme";
import useGeneral from "../hooks/useGeneral";
import moment from "moment";

type EarlyReturnListProps = {
    earlyReturnData: any[],
    setEarlyReturnRefresh: (value: boolean) => void;
    formattedCreatedAt: string;
    setPleaseWait: (value: boolean) => void;
}

const EarlyReturnList = ({
    earlyReturnData,
    setEarlyReturnRefresh,
    formattedCreatedAt,
    setPleaseWait
}: EarlyReturnListProps) => {
    const { themeStyles } = useTheme();
    const { dateFormat }: any = useGeneral();
    const [editEarlyReturnIsOpen, setEditEarlyReturnIsOpen] = useState<boolean>(false);
    const [modalData, setModalData] = useState<any>({});


    return (
        <div className="mt-2 w-full">
            <table className="min-w-full">
                <tbody className="text-left">
                    <tr className={`border-b ${themeStyles.main.borderColor}`}>
                        <th className={`w-[5%] text-[12px] font-semibold mb-2 pr-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>#</th>
                        <th className={`w-[25%] text-[12px] font-semibold mb-2 px-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Old Return</th>
                        <th className={`w-[25%] text-[12px] font-semibold mb-2 px-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>New Return</th>
                        <th className={`w-[25%] text-[12px] font-semibold mb-2 pl-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Comment</th>
                        <th className={`w-[10%] text-[12px] font-semibold mb-2 pl-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Created By</th>
                        <th className={`w-[10%] text-[12px] font-semibold mb-2 pl-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Created At</th>
                    </tr>

                    {
                        earlyReturnData?.map((item: any, index: number) => {
                            return (
                                <tr key={index} className={`border-b ${themeStyles.main.borderColor}`}>
                                    <td className="pr-[0.25rem] py-2 w-[5%] ">
                                        <span
                                            className={`text-xs font-medium underline text-[#0000ff] cursor-pointer`}
                                            onClick={() => {
                                                setModalData(item);
                                                setEditEarlyReturnIsOpen(true);
                                            }}
                                        >
                                            {item?.id}
                                        </span>
                                    </td>

                                    <td className="px-[0.25rem] py-2 w-[25%]">
                                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>
                                            {moment(new Date(item?.oldReturenDate)).format(dateFormat + " hh:mm a")}
                                        </span>
                                    </td>

                                    <td className="px-[0.25rem] py-2 w-[25%]">
                                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>
                                            {moment(new Date(item?.newReturenDate)).format(dateFormat + " hh:mm a")}
                                        </span>
                                    </td>

                                    <td className="pl-[0.25rem] w-[25%]">
                                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>{item?.comment}</span>
                                    </td>

                                    <td className="pl-[0.25rem] w-[10%]">
                                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>{item?.createdBy}</span>
                                    </td>

                                    <td className="px-[0.25rem] w-[25%]">
                                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>
                                            {item?.createdAt
                                                ? moment(new Date(item.createdAt)).format(dateFormat + " hh:mm a")
                                                : ""}
                                        </span>
                                    </td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>

            <EditEarlyReturnModal
                modalData={modalData}
                editEarlyReturnIsOpen={editEarlyReturnIsOpen}
                setEditEarlyReturnIsOpen={setEditEarlyReturnIsOpen}
                setEarlyReturnRefresh={setEarlyReturnRefresh}
                formattedCreatedAt={formattedCreatedAt}
                setPleaseWait={setPleaseWait}
            />
        </div>
    )
}

export default EarlyReturnList;